// extracted by mini-css-extract-plugin
export var deleteModal = "_hj-0";